// extracted by mini-css-extract-plugin
export default {"customCheckboxContainer":"customCheckbox_customCheckboxContainer__djHRU","labelCheckboxText":"customCheckbox_labelCheckboxText__549FV","noBgImage":"customCheckbox_noBgImage__DFuew"};